import { render } from "./keywordPage.vue?vue&type=template&id=efbd309c&scoped=true"
import script from "./keywordPage.vue?vue&type=script&lang=js"
export * from "./keywordPage.vue?vue&type=script&lang=js"

import "./keywordPage.vue?vue&type=style&index=0&id=efbd309c&lang=css"
import "./keywordPage.vue?vue&type=style&index=1&id=efbd309c&scoped=true&lang=scss"
import "./keywordPage.vue?vue&type=style&index=2&id=efbd309c&scoped=true&lang=css"
import "./keywordPage.vue?vue&type=style&index=3&id=efbd309c&scope=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbd309c"]])

export default __exports__